import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { getEPADetailsQuery } from '@/app/hooks/queries/useEarlyPhaseAssessment';
import { Main } from '@/app/ui/components/main';
import { ChatType, EvaluationTypeLabelsEnum } from '@/app/utils/constants';
import AIChatProvider from '@/app/components/features/aiChat/AIChatContext';
import useEntryChat from '@/app/components/features/aiChat/hooks/useEntryChat';
import { Sidechat } from '@/app/components/shared/Sidechat';
import { Spinner } from '@/app/ui/components/spinner';
import { useSuspenseQuery } from '@tanstack/react-query';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/early-phase-assessments/$earlyPhaseAssessmentId/_layout',
)({
  component: RouteComponent,
  loader: async (opts) => {
    const evaluation = await opts.context.queryClient.ensureQueryData(
      getEPADetailsQuery(opts.params.earlyPhaseAssessmentId),
    );
    if (!evaluation) throw notFound();
  },
  pendingComponent: () => (
    <Main className="relative">
      <Spinner kind="inset" />
    </Main>
  ),
});

function RouteComponent() {
  const { earlyPhaseAssessmentId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getEPADetailsQuery(earlyPhaseAssessmentId));

  const stream = useEntryChat({
    id: earlyPhaseAssessmentId,
    namespace: ChatType.EARLY_PHASE_ASSESSMENT,
  });

  return (
    <AIChatProvider
      chatType={ChatType.EARLY_PHASE_ASSESSMENT}
      sourceStream={stream}
      chatInitialOpen={false}
      evaluationName={evaluation.name}
      evaluationType={EvaluationTypeLabelsEnum.EARLY_PHASE_ASSESSMENT}
      evaluationId={earlyPhaseAssessmentId}
    >
      <Main>
        <Outlet />
      </Main>
      <Sidechat />
    </AIChatProvider>
  );
}
